module.exports = __webpack_public_path__ + "img/1F6E1.c476426d.svg";